import React from 'react';
import styled from 'styled-components';
import { media } from '../../utils/media';
import Skeleton from '../../ui/atoms/Skeleton';
import theme from '../../ui/theme';
import { toRgba } from '../../ui/theme/colors';

// Wrapper styled similarly to AllCoursesWrapper
const SkeletonWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 24px;

  ${media.lessThan('tablet')} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${media.lessThan('phablet')} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const CourseCardSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${theme.colors.NEU_0};
  box-shadow: 0 2px 8px ${toRgba(theme.colors.NEU_999, 0.1)};
  overflow: hidden;
`;

const CardImageWrapper = styled.div`
  height: 160px;
`;

const CardContentSkeleton = styled.div`
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const ButtonsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;

const ListCoursesSkeleton = ({ count = 6, showProgress = false, showButtons = false }) => {
  return (
    <SkeletonWrapper>
      {Array.from({ length: count }).map((_, index) => (
        <CourseCardSkeleton key={index}>
          <CardImageWrapper>
            <Skeleton.Base height='100%' />
          </CardImageWrapper>
          <CardContentSkeleton>
            <Skeleton.Circle size='40px' margin='0 0 12px 0' />
            <Skeleton.Text height='24px' width='80%' margin='0 0 12px 0' />
            <Skeleton.Text height='14px' width='90%' margin='0 0 8px 0' />
            <Skeleton.Text height='14px' width='75%' margin='0 0 8px 0' />

            <ButtonsRow>
              <Skeleton.Text height='36px' width='45%' />
              <Skeleton.Text height='36px' width='45%' />
            </ButtonsRow>
          </CardContentSkeleton>
        </CourseCardSkeleton>
      ))}
    </SkeletonWrapper>
  );
};

export default ListCoursesSkeleton;
